export class BerryConfig {
  static isCollapse_menu: boolean = false;
  static font_family: string = 'inter'; // Roboto, poppins, inter
}
